import _ from 'lodash';
import moment from 'moment';
import {
  DISTRICT,
  EXTERNAL_INTEGRATION,
  OPEN_TO_ALL_CITIES,
  ORDER_TYPE_CLICK_AND_COLLECT,
  STREET,
  STREET_NUMBER,
  SUBLOCALITY,
} from '../constants';
import { UPDATE_PENDING_ORDER, UPDATE_SHOPS } from '../redux/actions/types';
import { containsCircle, containsPolygon, getDistance } from './map';
import store from '../redux/store';
import { isShopUnavailable } from '../redux/actions';
import { isQrCode } from './config';
import { isStringNotNull } from './dataType';
import { getProductFees, priceWithPercentage } from './product';
import { getFirebaseCustomerId } from '../api/firebase/firebaseAuthentication';
import { getAllShops } from '../api/shops';
import { getPendingOrder } from '../api/pendingOrder';
import { logMediumError } from './logger';

export const getClosedMessage = (closed) => {
  const { shopName } = store.getState().shopReducer as any;
  if (typeof closed === 'string') {
    return closed;
  }
  return `${shopName} est exceptionnellement fermé pour le moment.`;
};

export const sortSlots = (slots, day) => {
  return _.sortBy(slots, (slot) => {
    const stringSlots = slot.split('-');
    return moment(`${day.format('YYYY-MM-DD')}T${stringSlots[0]}:00`);
  });
};

export const checkAndGetZoneData = (address, deliveryZones, openCities) => {
  const { city, district, street, subLocality, location } = address;
  let zoneData: any = null;
  let excludedZonesData = null;
  const sortedDeliveryZones = _.orderBy(deliveryZones, ['priority']).reverse();
  const zone = _.find(sortedDeliveryZones, (deliveryZone) => {
    const { shape, data } = deliveryZone;
    let containsZone = false;
    if (shape === 'circle') {
      containsZone = containsCircle(location, data, data.radius);
    } else {
      containsZone = containsPolygon(location, data);
    }
    return containsZone;
  });
  if (zone) {
    zoneData = {
      userServicePrice: zone.deliveryFees,
      minimum: zone.minimum,
    };
  }
  if (openCities && !zone) {
    const openCity = _.find(openCities, (cityTemp) => {
      return (
        city.toLowerCase() === cityTemp.name.toLowerCase() ||
        cityTemp.name === OPEN_TO_ALL_CITIES
      );
    });
    if (openCity) {
      const { userServicePrice, minimum, excludedZones } = openCity;
      zoneData = {
        userServicePrice,
        minimum,
      };
      excludedZonesData = excludedZones;
      if (isStringNotNull(subLocality) && openCity.subLocalities) {
        const openSubLocality = _.find(
          openCity.subLocalities,
          (subLocalityTemp) => {
            return (
              subLocality.toLowerCase() === subLocalityTemp.name.toLowerCase()
            );
          },
        );
        if (openSubLocality) {
          const { userServicePrice, minimum } = openSubLocality;
          zoneData = {
            userServicePrice,
            minimum,
          };
        }
      }
      if (district && openCity.districts) {
        const openDistrict = _.find(openCity.districts, (districtTemp) => {
          return district.toLowerCase() === districtTemp.name.toLowerCase();
        });
        if (openDistrict) {
          const { userServicePrice, minimum } = openDistrict;
          zoneData = {
            userServicePrice,
            minimum,
          };
          if (openDistrict.streets) {
            const openStreet = _.find(openDistrict.streets, (streetTemp) => {
              return street.toLowerCase() === streetTemp.name.toLowerCase();
            });
            if (openStreet) {
              const { userServicePrice, minimum } = openStreet;
              zoneData = {
                userServicePrice,
                minimum,
              };
            }
          }
        }
      }
    }
  }
  return { excludedZonesData, zoneData };
};

export const checkIfZoneExcluded = (address: any, excludedZones: any) => {
  return _.find(excludedZones, (excludedZone) => {
    switch (excludedZone.type) {
      case STREET:
        if (address.street.toLowerCase() === excludedZone.name.toLowerCase())
          return true;
        break;
      case STREET_NUMBER:
        if (
          `${address.streetNumber} ${address.street}`.toLowerCase() ===
          excludedZone.name.toLowerCase()
        )
          return true;
        break;
      case DISTRICT:
        if (
          address.district &&
          address.district.toLowerCase() === excludedZone.name.toLowerCase()
        )
          return true;
        break;
      case SUBLOCALITY:
        if (
          address.sublocality &&
          address.subLocality.toLowerCase() === excludedZone.name.toLowerCase()
        )
          return true;
        break;
      default:
        break;
    }
  });
};
const applyFee = (price, productFees) =>
  parseFloat(price) > 0 ? priceWithPercentage(price, productFees) : price;

const applyProductFeesToItem = (item, productFees: number) => {
  if (productFees) {
    item.price = applyFee(item.price, productFees);
    if (item.priceRef) {
      const { shopConfiguration } = store.getState().shopReducer as any;
      const shouldApplyPriceRefFee =
        shopConfiguration.externalIntegration?.type ===
          EXTERNAL_INTEGRATION.SPLASH &&
        shopConfiguration.externalIntegration?.enabled;
      if (shouldApplyPriceRefFee) {
        item.priceRef = applyFee(item.priceRef, productFees);
      }
    }
  }
};
export const parseSections = (sections: any, orderType?: string) => {
  if (!sections) {
    return {};
  }
  try {
    let productFees = getProductFees(orderType);
    let newSections: any[] = [];
    _.map(sections, (value, key) => {
      const section = value;
      let minimumPrice = 100;
      if (section) {
        if (section.productFees) {
          productFees = section.productFees;
        }
        _.map(section?.products, (product) => {
          const categories = product?.categories;
          applyProductFeesToItem(product, productFees);
          if (product?.categories) {
            let i = 0;
            const categoriesArray = categories.trim().split(',');
            const newCategories: string[] = [];
            _.map(categoriesArray, (category) => {
              newCategories.push(`${category}@${i}`);
              i += 1;
            });
            product.categories = newCategories.toString();
          }

          if (minimumPrice > parseFloat(product?.price)) {
            minimumPrice = parseFloat(product?.price);
          }
        });
        section.key = key;
        section.minimumPrice = minimumPrice;
      }
    });
    newSections = _.sortBy(sections, (section) => {
      return parseInt(section?.position, 10);
    });
    newSections = newSections.filter((section) => {
      return section;
    });
    return newSections;
  } catch (error) {
    logMediumError(`Error parsing section ${error}`, { orderType });
  }
};

export const parseCategories = (categories: any, orderType?: string) => {
  if (!categories) {
    return {};
  }
  let productFees = getProductFees(orderType);
  _.map(categories, (category) => {
    if (category?.productFees) {
      productFees = category.productFees;
    }
    _.map(category?.items, (item) => {
      applyProductFeesToItem(item, productFees);
      if (item && item.subcategories) {
        let i = 0;
        const categoriesArray = item.subcategories.trim().split(',');
        const newCategories: any[] = [];
        _.map(categoriesArray, (category) => {
          newCategories.push(`${category}@${i}`);
          i += 1;
        });
        item.subcategories = newCategories.toString();
      }
    });
  });
  return categories;
};

export const getShopData = (shop: any, zoneData: any) => {
  const newShop = shop;
  const { managementFee, admins, cancelFee = { type: '%', value: 100 } } = shop;
  let minimum = 0;
  let userServicePriceInfo = {
    userServicePrice: 0,
    userCancelServicePrice: cancelFee,
    managementFee: isQrCode() ? 0 : managementFee,
  };
  if (zoneData) {
    minimum = zoneData.minimum;
    let { userServicePrice } = zoneData;
    userServicePrice = _.sortBy(userServicePrice, ['priceOrder']);
    _.map(userServicePrice, (value, key) => {
      if (userServicePrice[key + 1]) {
        userServicePrice[key].nextPriceOrder =
          userServicePrice[key + 1].priceOrder;
        userServicePrice[key].nextFees = userServicePrice[key + 1].fees;
      }
    });
    userServicePriceInfo = {
      userServicePrice,
      userCancelServicePrice: cancelFee,
      managementFee: isQrCode() ? 0 : managementFee,
    };
  }
  newShop.userServicePriceInfo = userServicePriceInfo;
  const newAdmins: any[] = [];
  _.map(admins, (admin) => {
    newAdmins.push(admin);
  });
  newShop.admins = newAdmins;
  newShop.minimum = minimum;
  return newShop;
};

export const findFirstShopId = (
  shops: Record<string, any>,
  globalOrderTypes: string[] = [],
): string | null => {
  const shopIds = Object.keys(shops).sort();
  if (!shopIds.length) return null;

  const openMatch = shopIds.find((shopId) => {
    const shop = shops[shopId];
    if (!shop || shop.closed) return false;
    const shopOrderTypes = shop.configuration?.orderTypes ?? [];
    return shopOrderTypes.some((t: string) => globalOrderTypes.includes(t));
  });
  if (openMatch) return openMatch;

  const defaultOrderType = globalOrderTypes[0];
  if (defaultOrderType) {
    const orderTypeMatch = shopIds.find((shopId) =>
      (shops[shopId]?.configuration?.orderTypes ?? []).includes(defaultOrderType),
    );
    if (orderTypeMatch) return orderTypeMatch;
  }

  return shopIds[0];
};

export const getClosestShopsFromRedux = (
  orderType: string,
  address?: any
): any[] => {
  const { shops } = store.getState().shopReducer;
  if (!shops || !_.isObject(shops)) return [];
  const result: any[] = [];
  for (const [shopId, shop] of Object.entries(shops)) {
    if (!shop || (shop as any).hide) continue;
    const orderTypes = (shop as any).configuration?.orderTypes;
    if (orderTypes && !orderTypes.includes(orderType)) continue;
    const shopData = {
      ...shop,
      shopId,
      name: (shop as any).name,
      address: (shop as any).address,
    };
    if (address?.location && (shop as any).address?.location) {
      const { latitude, longitude } = (shop as any).address.location;
      shopData.distance = getDistance(
        address.location.latitude,
        address.location.longitude,
        latitude,
        longitude
      );
    }
    result.push(shopData);
  }
  return _.sortBy(result, ['distance']);
};

export const getShopsData = async () => {
  try {
    const shops = await getAllShops();
    store.dispatch({ type: UPDATE_SHOPS, payload: shops });
    return shops;
  } catch (error) {
    logMediumError(`Could not fetch shops ${error}`);
    throw error;
  }
};

export const getShopIdFromLink = () => {
  return window.location.pathname.split('/')[2];
};

const hasExistingPendingOrder = (pendingOrder: any): boolean => {
  if (!pendingOrder) {
    return false;
  }
  return Boolean(
    pendingOrder.shopId ||
      pendingOrder.orderType ||
      pendingOrder.address ||
      !_.isEmpty(pendingOrder.commande),
  );
};

export const getFirstShopId = async (): Promise<string | undefined> => {
  const customerId = getFirebaseCustomerId();

  const shops = !_.isEmpty(store.getState().shopReducer?.shops)
    ? store.getState().shopReducer?.shops
    : await getShopsData();
  const pendingOrder = await getPendingOrder(customerId);

  const globalOrderTypes =
    store.getState().configurationReducer?.orderTypes ?? [];

  const getFallbackShopId = () =>
    isQrCode() ? getShopIdFromLink() : findFirstShopId(shops, globalOrderTypes);

  const pendingOrderExists = hasExistingPendingOrder(pendingOrder);
  const resolvedShopId = pendingOrderExists
    ? pendingOrder?.shopId || getFallbackShopId()
    : isQrCode()
      ? getShopIdFromLink()
      : findFirstShopId(shops, globalOrderTypes);

  const defaultShopOrderTypes =
    shops?.[resolvedShopId]?.configuration?.orderTypes ?? [];
  const defaultOrderType = defaultShopOrderTypes.includes(
    ORDER_TYPE_CLICK_AND_COLLECT,
  )
    ? ORDER_TYPE_CLICK_AND_COLLECT
    : defaultShopOrderTypes[0] ?? ORDER_TYPE_CLICK_AND_COLLECT;

  const pendingOrderPayload: any = pendingOrderExists
    ? { ...pendingOrder }
    : {
        orderType: defaultOrderType,
      };

  store.dispatch({ type: UPDATE_PENDING_ORDER, payload: pendingOrderPayload });
  return resolvedShopId ?? undefined;
};

export const getShopAndZoneData = (
  shopId: string,
  shop: any,
  customerAddress: any,
  orderType: string,
) => {
  void orderType;
  if (!shop) {
    return null;
  }
  if (customerAddress) {
    const { zoneData } = checkAndGetZoneData(
      customerAddress,
      shop.deliveryZones,
      shop.openCities,
    );
    shop = getShopData(shop, zoneData);
  } else {
    const { sections, categories } = shop;
    shop.sections = parseSections(sections);
    shop.categories = parseCategories(categories);
  }
  shop.shopId = shopId;
  return shop;
};

export const getShopFromOrder = (order) => {
  const { shops } = store.getState().shopReducer;
  const { shopId } = order;
  let { shop } = order;
  if (!shop) {
    shop = _.find(shops, (shop, key) => {
      return shop && key === shopId;
    });
  }
  return shop || {};
};

export const checkIfShopAvailable = (
  _customerAddress: any,
  shopId: any,
  closestShops: any,
) => {
  let shopUnavailable: any = false;
  if (closestShops?.length) {
    const shopExists = closestShops?.find(
      (shop: any) => shop?.shopId === shopId,
    );
    if (!shopExists) {
      shopUnavailable = 'Service indisponible';
    }
  }
  store.dispatch(isShopUnavailable(shopUnavailable));
  return shopUnavailable;
};
